import { handleServiceCall } from '../../app/util/fetch-utils';
import { envConfigs } from '../../../envConfigs';

const egoPasswordUrl = envConfigs.egoApiHost + '/api/authentication/password/';
const totalePasswordUrl = envConfigs.totaleApiHost + '/api/forgot_password/';
const lpsApiHost = envConfigs.lpsApiHost;

export const loadPasswordMode = ({ userId, resetPasswordId }) => {
  const egoUrl = envConfigs.egoApiHost + '/api/authentication/password/policy';
  const postBody = {
    userGuid: userId,
    resetPasswordGuid: resetPasswordId
  };
  return fetch(egoUrl, {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache'
    }
  }).then((response) => {
    return handleServiceCall(response).then((passwordMode) => {
      return passwordMode;
    });
  });
};

export const requestServerPasswordReset = (username, namespace = '', accountType = '', locale = 'en-US') => {
  const postBody = {
    username: username,
    namespace: namespace,
    account_type: accountType,
    locale: locale
  };
  return fetch(lpsApiHost + '/api/authentication/password_reset', {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const requestServerPasswordResetOld = (emailAddress, token) => {
  const postBody = {
    client: 'Client.Launchpad.Web',
    email: emailAddress
  };
  return fetch(egoPasswordUrl + 'request', {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Authorization: 'Bearer ' + token,
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const processServerPasswordResetCatalyst = (requestUuid, password, authToken) => {
  const postBody = {
    token: requestUuid,
    new: password
  };
  return fetch(egoPasswordUrl + 'change', {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Authorization: 'Bearer ' + authToken,
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const processServerPasswordResetConsumer = (token, newPassword, passwordConfirmation) => {
  return fetch(totalePasswordUrl + 'reset/' + token, {
    method: 'POST',
    body:
      'user[password]=' +
      encodeURIComponent(newPassword) +
      '&user[password_confirmation]=' +
      encodeURIComponent(passwordConfirmation),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    referrerPolicy: 'origin-when-cross-origin',
    mode: 'cors'
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const processServerPasswordUpdate = (userUuid, newPassword, existingPassword, authToken) => {
  const postBody = {
    user: userUuid,
    new: newPassword,
    old: existingPassword
  };
  return fetch(egoPasswordUrl + 'change', {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Authorization: 'Bearer ' + authToken,
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const requestNarwhalPasswordReset = (email, locale = 'en-US') => {
  const postBody = {
    email: email,
    locale: locale
  };

  fetch(envConfigs.learnerNarwhalApiHost + '/api/resetPassword', {
    method: 'POST',
    body: JSON.stringify(postBody),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }).catch((error) => {
    // Silently ignore errors (CORS, network, etc.)
    console.log('Password reset request sent (errors ignored for security)');
  });

  // Return resolved promise immediately
  return Promise.resolve({ success: true });
};

export const specialPasswordChars = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';



// WEBPACK FOOTER //
// ./src/modules/login/services/password-change-helpers.js